<script>import VegaEmbed from "./VegaEmbed.svelte";
export let spec;
export let options = {};
export let data = {};
export let signalListeners = {};
export let view = void 0;
const mode = "vega";
$:
  vegaOptions = { ...options, mode };
</script>

<VegaEmbed
	{spec}
	{data}
	{signalListeners}
	options={vegaOptions}
	bind:view
	on:onNewView
	on:onError
/>
